import { ITableEditOption } from '@Utils/helpers/tableHelpers';
import React from 'react';
import { useSelector } from 'react-redux';
import { handleCellInputChange } from './Helpers';
import Styles from './SettingsTable.scss';

interface IEditEntityTableRowProps {
    updateEntity: any;
    onChangeUpdateEntity: (obj: any) => void;
    cells?: Array<ITableEditOption>;
    isSubmitting?: boolean;
    id?: string;
}

const EditEntityTableRow = (props: IEditEntityTableRowProps) => {
    const handleRowInputChange = (event) => {
        const updatedCreateObj = handleCellInputChange(
            event,
            props.updateEntity
        );
        props.onChangeUpdateEntity(updatedCreateObj);
    };

    const tds = props.cells.map((cell, i) => {
        let innerComponent = <span>-</span>;

        if (cell.component) {
            innerComponent = cell.isStandalone
                ? cell.component
                : React.cloneElement(cell.component, {
                      onChange: handleRowInputChange,
                      disabled: props.isSubmitting,
                      name: cell.attribute,
                      value: props.updateEntity[cell.attribute],
                      checked: props.updateEntity[cell.attribute],
                  });
        }
        return <td key={i}>{innerComponent}</td>;
    });

    return (
        <tr id={props.id} className={Styles.createObjRow}>
            {tds}
        </tr>
    );
};

export default EditEntityTableRow;
